var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex h-screen bg-background-light overflow-hidden font-sans"},[_c('Sidebar',{on:{"logout":_vm.handleLogout}}),_c('div',{staticClass:"flex-1 flex flex-col overflow-y-auto"},[_c('TopBar',{attrs:{"title":_vm.pageTitle}}),_c('main',{staticClass:"p-8 w-full max-w-[1200px] mx-auto"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }